import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetCourts(club) {

  var url = "/class_app/" + club + "/admin/courts";

  return FetchGetDataWithAuthNEW(url);
}

